module.exports = __webpack_public_path__ + "static/img/arg_logo.5784aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arg_logo.png
// module id = +AHo
// module chunks = 10